import React from "react";
import {Grid} from "@mui/system";
import style from "../../assets/css/home.module.scss";
import Accordion from "@mui/material/Accordion";
import AccordionDetails from "@mui/material/AccordionDetails";
import AccordionSummary from "@mui/material/AccordionSummary";
import Typography from "@mui/material/Typography";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

const accordionData = [
  {
    id: "panel1",
    title: "What does Jewelers Block Insurance cover ?",
    content:
      "Our policies cover, but are not limited to, stock on-premises, in transit, at exhibitions, and while entrusted to third parties. Coverage extends to risks such as theft, burglary, damage, mysterious disappearance, travel-related losses, and even terrorism-related incidents, ensuring comprehensive protection against unforeseen events.",
  },
  {
    id: "panel2",
    title: "Can I get coverage for international trade shows and exhibitions ?",
    content:
      "Yes, this can be with or without transit coverage, depending on your needs. We offer flexible options to ensure your inventory remains protected while on display or in transit.",
  },
  {
    id: "panel3",
    title:
      "What makes Associated International Brokers, Inc different from other brokers ?",
    content:
      "Our hands-on experience in the jewelry trade gives us a deeper understanding of the unique risks associated with high-value assets. Combined with competitive pricing and personalized service, we ensure our clients receive tailored coverage that aligns with their business needs.",
  },
  {
    id: "panel4",
    title: "What happens if my jewelry is lost or stolen in transit ?",
    content:
      "Our policies provide comprehensive transit coverage, including shipments via approved carriers and Armored transport services. Claims are handled swiftly to minimize disruptions to your business.",
  },
  {
    id: "panel5",
    title:
      "How do I start a policy with Associated International Brokers, Inc ?",
    content:
      "Simply fill out our online form to receive a soft-quote. Our team will then conduct a thorough risk analysis and provide a hard-quote, ensuring your coverage meets your specific needs.",
  },
  {
    id: "panel6",
    title: "How do I report a claim ?",
    content:
      "Simply call your agent or file a claim through your account on our platform. Our team will assist you promptly to ensure a smooth claims process.",
  },
  {
    id: "panel7",
    title: "How do I add endorsements ?",
    content:
      "Additional coverages can be requested through your account on our platform. Ideally, we would appreciate if you could notify us a few days in advance to allow our underwriters sufficient time to assess and process the risk effectively.",
  },
];

function Faq() {
  const [expanded, setExpanded] = React.useState(true);

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  return (
    <>
      <section className={style.FaqSuryaSection}>
        <Grid
          container
          spacing={2}
          className="customeContainer"
          justifyContent="center"
        >
          <Grid size={{xs: 12, lg: 6, xl: 12}} sx={{mb: 2}}>
            <div className={style.FaqTitle} style={{textAlign: "center"}}>
              <h2> Frequently Asked Questions </h2>
              {/* <p>
                                Lorem Ipsum is simply dummy text of the printing <br />
                                and typesetting industry.
                            </p> */}
            </div>
          </Grid>
        </Grid>

        <Grid
          container
          spacing={{xl: 2, lg: 2, sm: 0, xs: 0}}
          className="customeContainer"
          justifyContent="center"
        >
          <Grid size={{xs: 12, lg: 6, xl: 5}} className="faq_accordion">
            <div className={style.FaqMain}>
              {accordionData.slice(0, 4).map((panel, pId) => (
                <Accordion
                  key={panel.id}
                  expanded={expanded === panel.id}
                  onChange={handleChange(panel.id)}
                  defaultExpanded
                >
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls={`${panel.id}-content`}
                    id={`${panel.id}-header`}
                  >
                    <Typography
                      component="span"
                      sx={{width: "100%", flexShrink: 0}}
                    >
                      <h3>{panel.title}</h3>
                    </Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    <Typography>
                      <>{panel.content}</>
                    </Typography>
                  </AccordionDetails>
                </Accordion>
              ))}
            </div>
          </Grid>
          <Grid size={{xs: 12, lg: 6, xl: 5}} className="faq_accordion">
            <div className={style.FaqMain}>
              {accordionData.slice(4, 7).map((panel) => (
                <Accordion
                  key={panel.id}
                  expanded={expanded === panel.id}
                  onChange={handleChange(panel.id)}
                >
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls={`${panel.id}-content`}
                    id={`${panel.id}-header`}
                  >
                    <Typography
                      component="span"
                      sx={{width: "100%", flexShrink: 0}}
                    >
                      <h3>{panel.title}</h3>
                    </Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    <Typography>
                      <>{panel.content}</>
                    </Typography>
                  </AccordionDetails>
                </Accordion>
              ))}
            </div>
          </Grid>
        </Grid>
      </section>
    </>
  );
}

export default Faq;
